import React from 'react';
import PropTypes from 'prop-types';
import { ROUTES } from '../../../router';
import styles from '../../../styles/views/components/FeedbacksTable/FeedbackInfo.module.scss';

const FeedbackInfo = ({ row, colSpan }) => {
  const rating = row?.original;

  return (
    <tr>
      <td colSpan={colSpan} className={styles.container}>
        <div className={styles.feedback}>
          {!rating.isProjectDeleted && (
            <a href={ROUTES.projects.overview.byProjectId.url(rating.projectId)}>
              {t('button.goToProject', { ns: i18next.Namespace.COMMON })}
            </a>
          )}
          <label className={styles.label}>{t('feedback')}</label>
          <div className={styles.textArea}>
            {rating?.feedbackMessage}
          </div>
        </div>
      </td>
    </tr>
  );
};

FeedbackInfo.propTypes = {
  row: PropTypes.object.isRequired,
  colSpan: PropTypes.string.isRequired,
};

export default FeedbackInfo;
